import { LiftWarningLevel } from 'src/app/core/graphql/generated/gen-types';

/**
 * Presentation helpers for the four-zone lift warning (111-balloon-lift-warning), shared by the
 * badge component and the mobile pilot card so class, glyph, label and palette can never drift.
 *
 * The level itself is judged server-side against the balloon's thresholds and its MLM (minimum
 * landing mass, checked on the worst-case landing mass — takeoff minus all burnable gas);
 * nothing here judges anything.
 */

export function liftLevelClass(level: LiftWarningLevel | null): string {
	switch (level) {
		case LiftWarningLevel.Green:
			return 'lift-green';
		case LiftWarningLevel.Orange:
			return 'lift-orange';
		case LiftWarningLevel.Red:
			return 'lift-red';
		case LiftWarningLevel.Blue:
			return 'lift-blue';
		default:
			return 'lift-unknown';
	}
}

// The lift badge always shows the scale glyph (weight family, like the pax default-weight
// warning) — the level speaks through colour and tooltip. Deliberately unlike flyability's
// per-verdict glyphs: lift is one weight story in four states.
export function liftLevelIcon(level: LiftWarningLevel | null): string {
	return 'scale';
}

export function liftLevelLabel(level: LiftWarningLevel | null): string {
	switch (level) {
		case LiftWarningLevel.Green:
			return 'FLIGHTS.lift_level_green';
		case LiftWarningLevel.Orange:
			return 'FLIGHTS.lift_level_orange';
		case LiftWarningLevel.Red:
			return 'FLIGHTS.lift_level_red';
		case LiftWarningLevel.Blue:
			return 'FLIGHTS.lift_level_blue';
		default:
			return 'FLIGHTS.lift_level_unknown';
	}
}
